import { RelayEnvironmentProvider } from 'react-relay';

import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import { Localization } from 'src/components/LayoutComponents/Localization';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'connected-react-router';
import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { createHashHistory } from 'history';
import { sagas } from 'src/redux/sagas';
import { reducers } from 'src/redux/reducers';
import * as serviceWorker from './serviceWorker';
import { RelayEnvironment } from './relay/RelayEnvironment';
import { Router } from './router';

// app styles
import './global.scss';

const history = createHashHistory();
const sagaMiddleware = createSagaMiddleware();
const routeMiddleware = routerMiddleware(history);
const middlewares = [thunk, sagaMiddleware, routeMiddleware];
const store = createStore(reducers(history), compose(applyMiddleware(...middlewares)));
sagaMiddleware.run(sagas);
serviceWorker.unregister();

createRoot(document.getElementById('root')!).render(
  <RelayEnvironmentProvider environment={RelayEnvironment}>
    <ConfigProvider
      theme={{
        hashed: false,
        token: {
          fontFamily: "'Nunito Sans',sans-serif",
        },
      }}
    >
      <Provider store={store}>
        <Localization>
          <Router history={history} />
        </Localization>
      </Provider>
    </ConfigProvider>
  </RelayEnvironmentProvider>,
);

export { store, history };
